import { render } from "./TopNav.vue?vue&type=template&id=2f4791f6"
import script from "./TopNav.vue?vue&type=script&lang=js"
export * from "./TopNav.vue?vue&type=script&lang=js"

import "./TopNav.vue?vue&type=style&index=0&id=2f4791f6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__